import { Directive, ElementRef, Input } from "@angular/core";
import interact from "interactjs";

@Directive({
  selector: "[draggableInteract]",
  standalone: false
})
export class DraggableInteractDirective {
  @Input("draggableInteract")
  draggableInteract!: HTMLDivElement;

  private readonly floatingPosition = { x: 0, y: 0 };

  constructor(elementRef: ElementRef<HTMLDivElement>) {
    interact(elementRef.nativeElement).draggable({
      inertia: true,
      listeners: {
        move: (event: { dx: number; dy: number }) => {
          this.floatingPosition.x += event.dx;
          this.floatingPosition.y += event.dy;

          this.draggableInteract.style.transform = `translate(${this.floatingPosition.x}px, ${this.floatingPosition.y}px)`;
        }
      }
    });
  }
}
